import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { UniqueIdentifier } from "@dnd-kit/core";

type SortableItemProps = {
  id: UniqueIdentifier;
  children: React.ReactNode;
  disabled?: boolean;
};

export const SortableItem: React.FC<SortableItemProps> = ({
  id,
  children,
  disabled,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {isDragging ? null : children}
    </div>
  );
};
